module.exports = __webpack_public_path__ + "static/media/rsna18-group-2.2b4510f2.svg";